"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compose = void 0;
var React = require("react");
var Compose = exports.Compose = function Compose(_ref) {
  var _ref$components = _ref.components,
    components = _ref$components === void 0 ? [] : _ref$components,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, components.reduceRight(function (acc, _ref2) {
    var Component = _ref2.Component,
      props = _ref2.props;
    return /*#__PURE__*/React.createElement(Component, props, acc);
  }, children));
};